/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2020 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers.  The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

import { xBaseTheme } from "@eisinc/XDL/types";
import printStyles, { onPrint } from "@eisinc/XDL/Utilities/print";
import { TabProps } from "@insite/mobius/Tab";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

export default {
    defaultProps: {
        css: css`
            flex: 1 1 20%;
            text-algin: center;
            height: 36px;
            position: relative;
            color: ${getColor("text.main")};
            border: 2px solid ${getColor("transparent")};
            font-size: 16px;
            font-weight: normal;
            letter-spacing: 0;
            line-height: 36px;
            padding: 0 20px;
            transition: color 0.2s;
            cursor: pointer;
            margin-right:3px;
            min-width: initial;
            max-width: 280px;

            &:last-child {
                margin-right:0;
            }

            &:before {
                content: "";
                position: absolute;
                top: 0;
                left: 0;
                height: 4px;
                width: 100%;
                background-color: ${({ selected, theme }: TabProps) =>
                    selected ? getColor("primary") : getColor("transparent")};
            }

            &:after {
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                height: 100%;
                width: 100%;
                content: "${(props: any) => props.headline}";
                display: block;
                color: ${getColor("transparent")};
                font-weight: bold;
                transition: color 0.2s;
                line-height: 36px;
            }

            &:hover {
                border-bottom: 0;
                color: ${getColor("transparent")};

                &:after {
                    color: ${getColor("text.main")};
                }
            }

            &:focus {
                outline: none;
                color: ${getColor("text.main")};
                background: ${getColor("common.ui2")};
                border: 2px solid #63747F;
                &:after {
                    color: ${getColor("transparent")};
                }
            }
            
            && {
                background: ${({ selected, theme }: TabProps) =>
                    selected ? getColor("common.white") : getColor("common.ui2")};

                &:focus {
                    border-color: ${({ selected, theme }: TabProps) =>
                        selected ? getColor("transparent") : getColor("common.border")};
                }
            }
        `,
    },
    groupDefaultProps: {
        cssOverrides: {
            wrapper: css`
                padding: 0;
                display: block;
            `,
            tabGroup: css`
                overflow-y: hidden;
                position: relative;
                padding-bottom: 0;
                z-index: 0;
                ${printStyles.hideOnPrint}
            `,
            tabContent: css`
                border: none;
                padding: 25px 0;

                ${onPrint(css`
                    display: block !important;
                    border: 1px solid ${getColor("common.ui1")};
                    padding: 5px;
                    margin-bottom: 20px;
                    ${printStyles.avoidBreakInside}

                    * {
                        height: auto;
                    }
                `)}
            `,
        },
    },
} as xBaseTheme["tab"];
